export default {
  StructureAdmin: 'structure_admin',
  DepartmentAdmin: 'structure_admin',
  EstablishmentAdmin: 'establishment_admin',
  Professor: 'professor_user',
};
